import React from 'react'
import styled from 'styled-components'
import img1 from '../../assets/Nfts/bighead-1.svg'
import img2 from '../../assets/Nfts/bighead-2.svg'
import img3 from '../../assets/Nfts/bighead-3.svg'
import ConfettiComponent from '../Confetti'

const Section = styled.section`
  background-color: ${props => props.theme.body};
  min-height: 100vh;
  position: relative;
  width: 100vw;
`

const Container = styled.div`
  align-items: center;
  background-color: ${props => props.theme.body};
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 2rem auto;
  width: 75%;
`

const Item = styled.div`
  border-radius: 20px;
  backdrop-filter: blur(4px);
  border: 2px solid ${props => props.theme.text};
  color: ${props => props.theme.body};
  margin: 2rem 1rem;
  padding: 1rem 0;
  position: relative;
  width: calc(20rem - 4vw);
  z-index: 5;

  &:hover{
    img{
      transform: translateY(-2rem) scale(1.2);
    }
  }
`
const ImgContainer = styled.div`
  background-color: ${props => props.theme.carouselColor};
  border: 1px solid ${props => props.theme.text};
  border-radius: 20px;
  cursor: pointer;
  margin: 0 auto;
  width: 14rem;

  img {
    height: auto;
    transition:  0.3s ease;
    width: 100%;
  }
`
const Name = styled.h2`
  font-size: ${props => props.theme.fontlg};
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  color: ${props => props.theme.text};
  margin-top: 1rem;
`

const Position = styled.h2`
  font-size: ${props => props.theme.fontmd};
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: capitalize;
  color: ${props => `rgba(${props.theme.textRgba},0.9)`};
  margin-top: 1rem;
  font-weight: 400;
`
const Title = styled.h1`
  align-items: center;
  border-bottom: 2px solid ${props => props.theme.text};
  color: ${props => props.theme.text};
  display: flex;
  font-size: ${props => props.theme.fontxxl};
  justify-content: flex-start;
  margin: 1rem auto;
  text-transform: capitalize;
  width: fit-content;
`

const MemberComponent = ({img, name="", position=""}) => {
  return (
    <Item>
      <ImgContainer>
        <img src={img} alt={name} />
      </ImgContainer>
      <Name>{name}</Name>
      <Position>{position}</Position>
    </Item>
  )
}

const Team = () => {
  return (
    <Section id="team">
      <ConfettiComponent />
      <Title>Team</Title>
      <Container>
        <MemberComponent img={img1} name="BHAVYA" position="Co-Founder, CTO"/>
        <MemberComponent img={img2} name="BILLNYELIKESTHIGHS" position="Co-Funder, COO"/>
        <MemberComponent img={img3} name="NUBBY" position="Partner, L2Labs Co-Founder"/>
      </Container>
    </Section>
  )
}

export default Team
